import React, { useEffect } from 'react'
import { Col, Form, Input, Row } from 'antd'
import { useNavigate, useParams } from 'react-router-dom';
import { GetLoggedInUser } from '../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';
import { UserServices } from '../../../redux/Services';
import HeadingBack from '../../../component/HeadingBack';
import { usePermission } from '../../../hooks/usePermission';
import { UserId } from "../../../utils/";
import { preventHtml } from '../../../utils/validation';
import LoadingButton from '../../../component/LoadingButton';
import { useAsyncAction } from '../../../hooks/useAsyncAction';
const EditRoles = () => {
    const permission = usePermission("Users Management", "Edit");
    let LOG_IN_USER = GetLoggedInUser();
    const { roleId } = useParams();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const roleData = useSelector(state => state.user.roleDetail || {});
    const { mutate: fetchRoleById } = useMutation((data) => dispatch(UserServices.fetchRolesByIdApi(data, roleId)));
    const { mutateAsync: updateRole } = useMutation((data) => dispatch(UserServices.updateRolesApi(data, roleId, navigate)));
    useEffect(() => {
        if (roleId) {
            fetchRoleById({UserId:UserId});
        }
        return () => { }
    }, [roleId])

    useEffect(() => {
        if (roleData && Object.keys(roleData)?.length > 0) {
            form.setFieldValue('Role', roleData?.Role);
            form.setFieldValue('AdditionalInfo', roleData?.AdditionalInfo);
        }
    }, [roleData])

    const [handleSubmit, submitting] = useAsyncAction((values) => {
            if (roleId) {
                let _data = { ...values };
                _data.UserId = LOG_IN_USER?.UserId;
                return updateRole(_data);
            }
    })
    return (
        <>
            <HeadingBack title={"Role Edit"} subHeading="" />
            <div className='p-20'>
                <Row>
                    <Col lg={12} md={24} sm={24} xs={24}>
                        < Form
                            form={form}
                            name="basic"
                            layout={"vertical"}
                            initialValues={{
                                Role: "",
                                AdditionalInfo: ""
                            }}
                            autoComplete="off"
                            onFinish={handleSubmit}
                        >
                            <Form.Item
                                label="Role"
                                name="Role"
                                rules={[{ required: true, message: 'Role is required' }]}
                            >
                                <Input autoComplete="off" className='form-control' placeholder='Role' onInput={preventHtml}/>
                            </Form.Item>
                            <Form.Item
                                label="Additional Field"
                                name="AdditionalInfo"
                            >
                                <Input.TextArea onInput={preventHtml} autoComplete="off" className='form-control' placeholder='Enter Text' rows={4} maxLength={100} />
                            </Form.Item>
                            <div className='text-center'>
                                <LoadingButton key="submit" type="submit" className='gradient-button w-auto' loading={submitting}>
                                    Update
                                </LoadingButton>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default EditRoles